import { Component } from "@angular/core";

@Component({
    selector: "app-create-account",
    templateUrl: "./create-account.page.html",
    styleUrls: ["./create-account.page.scss"]
})
export class CreateAccountPage {}
